import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env, isSupabaseConfigured, requireEnv } from "@/lib/env";

let client: SupabaseClient | null = null;

/**
 * Lazy Supabase client. We avoid constructing at module load so the app
 * can render without a configured .env (useful for the first dev session
 * before a Supabase project exists).
 */
export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(
      requireEnv("SUPABASE_URL"),
      requireEnv("SUPABASE_ANON_KEY"),
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          flowType: "pkce",
        },
      },
    );
  }
  return client;
}

export { env, isSupabaseConfigured };
